module.exports = __webpack_public_path__ + "fonts/iconfont.5aa98aa.woff2";